$('body').on('change', '.invoice-payment input[name="payment_option"]', function() {
    var method = $(this).val();
    if(method === 'saved') {
    	$('.invoice-payment input[name="card"]').val('');
    	$('.select-saved-card-trigger').removeClass('active');
    	$('.payment-method[data-method="saved"]').removeClass('hidden');
    	$('.payment-method[data-method="saved"] input').each(function() {
    		var input = $(this);
    		input.prop('disabled', false);
    		if(input.attr('data-required')) {
    			input.addClass('required');
    		}
    	});
    	$('.payment-method[data-method="new"]').addClass('hidden');
    	$('.payment-method[data-method="new"] input').each(function() {
			var input = $(this);
    		input.prop('disabled', true);
			input.removeClass('required');
    	});

        // if we only have one saved card select it
        if($('.select-saved-card-trigger').length == 1) {
            $('.select-saved-card-trigger').addClass('active');
            $('.invoice-payment input[name="card"]').val($('.select-saved-card-trigger').attr('data-card'));
        }
    	return;
    }

    if(method === 'new') {
    	$('.invoice-payment input[name="card"]').val('');
    	$('.select-saved-card-trigger').removeClass('active');
    	$('.payment-method[data-method="new"]').removeClass('hidden');
    	$('.payment-method[data-method="new"] input').each(function() {
    		var input = $(this);
    		input.prop('disabled', false);
    		if(input.attr('data-required')) {
    			input.addClass('required');
    		}
    	});
    	$('.payment-method[data-method="saved"]').addClass('hidden');
    	$('.payment-method[data-method="saved"] input').each(function() {
			var input = $(this);
    		input.prop('disabled', true);
			input.removeClass('required');
    	});
    	return;
    }
});

$('body').on('click', '.invoice-payment .select-saved-card-trigger', function() {
    $('.select-saved-card-trigger').removeClass('active');
    var $this = $(this);
    $this.addClass('active');
    $('input[name="card"]').val($this.attr('data-card'));
    return false;
});


$('body').on('submit', '.invoice-payment form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;
    var card = $this.parents('.card');
    card.find('.error').removeClass('error');
    card.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!card.find('input[name="'+input.attr('name')+'"]:checked').length) {
                console.log(input.attr('name'));
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                console.log(input.attr('name'));
                error = true;
            }
        }

        if(input.val() === '') {
            console.log(input.attr('name'));
            error = true;
            input.addClass('error');
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();
            closeModal();
            showError(data.success ? 'Success' : 'Error', data.message);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-card', function(data) {
    // console.log(data);
    if($('.invoice-payment').length) {
        $('.invoice-payment input[name="payment_option"][value="saved"]').parents('.radio-option').removeClass('hidden');
        $('.invoice-payment input[name="payment_option"][value="saved"]').prop('checked', true);
        $('.invoice-payment input[name="card"]').val(data.card);
        $('.select-saved-card-trigger').removeClass('active');
        $('.payment-method[data-method="saved"]').removeClass('hidden');
        $('.payment-method[data-method="saved"] input').each(function() {
            var input = $(this);
            input.prop('disabled', false);
            if(input.attr('data-required')) {
                input.addClass('required');
            }
        });
        $('.payment-method[data-method="new"]').addClass('hidden');
        $('.payment-method[data-method="new"] input').each(function() {
            var input = $(this);
            input.prop('disabled', true);
            input.removeClass('required');
        });

        $('.payment-method[data-method="saved"] .cards').append(`<a href="" class="saved-card select-saved-card-trigger active" data-card="${data.card}">
            <div class="card-info">
                <div class="card-type-small">
                    <figure>
                        <img src="images/payment-type-${data.card_type}.svg" alt="profile">
                    </figure>
                </div>

                <ul class="details-list table">
                    <li><span>Card Holder</span> <span class="highlight" data-input="card_holder" data-color="white">${data.card_holder}</span></li>
                    <li><span>Card Type</span> <span class="highlight" data-input="card_type_parsed" data-color="white">${data.card_type}</span></li>
                    <li><span>Number</span> <span class="highlight" data-input="masked_number" data-color="grey">${data.masked_number}</span></li>
                    <li><span>Expiry</span> <span class="highlight" data-input="expiry" data-color="white">${data.expiry}</span></li>
                </ul>
            </div>
        </a>`);
        return;
    }
});

channel.bind('process-invoice-payment', function(data) {
    // console.log(data);
    if($('.invoice-payments').length) {
        var method;
        if(data.is_card) {
            method = `<td class="flex-wrapper">
                    <div class="flex">
                        <figure>
                            <img src="images/icons/${data.card_type}.svg" alt="carrier">
                        </figure>
                        <p>${data.masked_number} <span>${data.card_holder}</span></p>
                    </div>
                </td>`;
        } else {
            method = `<td>${data.method}</td>`;
        }

        $('.invoice-payments tbody').append(`<tr class="payment" data-payment="${data.payment}">
            <td data-input="description">${data.description}</td>
            <td data-input="amount_parsed">${data.amount_parsed}</td>
            ${method}
            <td><span class="highlight" data-input="status" data-color="${data.status_color}">${data.status}</span></td>
            <td data-input="payment_date_parsed">${data.payment_date_parsed}</td>
        </tr>`);
    }
});

channel.bind('process-invoice-user', function(data) {
    // console.log(data);
    if($('.invoice-payment').length) {
        $('.invoice-payment [data-input="user_balance_parsed"]').html(data.balance_parsed);
    }
});